/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { clamp } from './clamp'

const MIN_VALUE = 0

export const computeProgressRatio = (value: number, max: number) => {
  if (max <= MIN_VALUE) return MIN_VALUE

  return (clamp(value, max) / max) * 100
}
